<template>
  <nuttrema-layout-content>
    <template slot="header">
      <stuff-to-eat-standard-header
        :edit.sync="edit"
        :meta="meta"
        :StuffToEatDetails="StuffToEatDetails">
      </stuff-to-eat-standard-header>
    </template>

    <template slot="central">
      <nuttrema-loader v-if="StuffToEatDetails.fetching || StuffToEatTypeCategories.fetching"></nuttrema-loader>
      <form-stuff-to-eat-main-details-cred
         v-else
        :id="id"
        :edit.sync="edit"
        :StuffToEatDetails="StuffToEatDetails"
        :StuffToEatTypeCategories="StuffToEatTypeCategories"
        @delete="onDelete"
        @submit="onFormSubmit">
      </form-stuff-to-eat-main-details-cred>
    </template>
  </nuttrema-layout-content>
</template>

<script>
import { mapActions } from 'vuex';

import PageProps from 'components/mixins/page-props';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import StuffToEatStandardHeader from 'components/pages/professional/stuff-to-eat/shared/blocks/cmpt-stuff-to-eat-standard-header';

import FormStuffToEatMainDetailsCred from './form-stuff-to-eat-main-details-cred';

export default {
  name: 'page-stuff-to-eat-main-details-view',
  mixins: [PageProps],
  props: {
    id: {
      required: false,
      default: null,
    },
    type: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      edit: false,
    };
  },
  components: {
    NuttremaLayoutContent,
    StuffToEatStandardHeader,
    FormStuffToEatMainDetailsCred,
  },
  computed: {
    StuffToEatDetails() {
      return this.$store.getters.StuffToEatDetails(this.id);
    },
    StuffToEatTypeCategories() {
      return this.$store.getters.StuffToEatTypeCategories(this.type);
    },
  },
  methods: {
    ...mapActions([
      'SaveStuffToEatDetails',
      'DeleteStuffToEat',
    ]),
    onFormSubmit(payload) {
      this.SaveStuffToEatDetails({ id: this.id, type: this.type, payload }).then(() => {
        this.successNotification({ label: 'label.stuff_to_eat' });
      }).catch((error) => {
        console.error(error);
        this.errorNotification();
      });
    },
    onDelete() {
      this.DeleteStuffToEat({ id: this.id, type: this.type }).then(() => {
        this.successNotification({ label: 'label.stuff_to_eat', message: 'message.default_success_added_message' });
        this.onSuccessEvent();
      }).catch((error) => {
        console.error(error);
        this.errorNotification({ label: 'label.stuff_to_eat', message: 'message.default_error_added_message' });
      });
    },
  },
  created() {
    this.$store.dispatch('GetStuffToEatTypeCategories', { type: this.type, query: { entity_id: this.id } });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearStuffToEatTypeCategories', { type: this.type });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/main-details/page-stuff-to-eat-main-details-view.vue